import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "eyebrow text-primary" }
const _hoisted_2 = { class: "my-3 h-display letterpress" }
const _hoisted_3 = { class: "text-base md:text-lg" }
const _hoisted_4 = {
  key: 0,
  class: "mt-6 text-left"
}
const _hoisted_5 = {
  class: "rounded-md border border-default bg-elevated p-4 text-sm",
  open: ""
}
const _hoisted_6 = { class: "cursor-pointer font-mono font-semibold" }
const _hoisted_7 = { class: "mt-3 space-y-2 font-mono text-xs" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "break-all" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "break-all" }
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { class: "break-all whitespace-pre-wrap" }
const _hoisted_14 = { key: 3 }
const _hoisted_15 = { class: "overflow-auto whitespace-pre-wrap break-all" }
const _hoisted_16 = { key: 4 }
const _hoisted_17 = { class: "overflow-auto whitespace-pre-wrap text-xs" }
const _hoisted_18 = { class: "mt-3 flex flex-col items-center justify-center gap-4 sm:flex-row" }

import type { NuxtError } from '#app'
import { domMax, LazyMotion, MotionConfig } from 'motion-v'


export default /*@__PURE__*/_defineComponent({
  __name: 'error',
  props: {
    error: {}
  },
  setup(__props: any) {

const props = __props

const route = useRoute()
const monsterClicks = useState('mm:monster-clicks', () => 0)
const colorMode = useColorMode()

const statusCode = computed(() => props.error.statusCode ?? 500)
const is404 = computed(() => statusCode.value === 404)
const isServerError = computed(() => statusCode.value >= 500)
const errorContent = computed(() => {
  if (is404.value) {
    return {
      title: 'Page Gobbled Up',
      message: 'We couldn\'t find that page. Maybe it got folded into the paper pile.',
      image: '/image/illustrations/404.svg',
      imageWidth: 270,
      imageHeight: 180,
      primaryLabel: 'Head Home',
      primaryAction: goHome,
      secondaryLabel: 'See Games',
      secondaryAction: goGames,
    }
  }

  if (isServerError.value) {
    return {
      title: statusCode.value === 500 ? 'Monster Machinery Jammed' : 'Something Went Sideways',
      message: 'Something got a bit too monstrous on our end. Try again in a moment.',
      image: '/image/illustrations/contact.svg',
      imageWidth: 302,
      imageHeight: 151,
      primaryLabel: 'Try Again',
      primaryAction: retryRoute,
      secondaryLabel: 'Head Home',
      secondaryAction: goHome,
    }
  }

  return {
    title: 'Something Went Sideways',
    message: props.error.statusMessage || 'This page could not be loaded.',
    image: '/image/illustrations/home.svg',
    imageWidth: 302,
    imageHeight: 173,
    primaryLabel: 'Try Again',
    primaryAction: retryRoute,
    secondaryLabel: 'Head Home',
    secondaryAction: goHome,
  }
})

const pageForcesDark = computed(() => route.path === '/games/cult-of-the-lamb')
const effectiveDark = computed(() => pageForcesDark.value || colorMode.value === 'dark')
const isAdminRoute = computed(() => route.path === '/admin' || route.path.startsWith('/admin/'))

const { isAdmin } = useAdminSession()
const showErrorDetails = computed(() => isAdminRoute.value && isAdmin.value)
const errorDetails = computed(() => {
  if (!showErrorDetails.value)
    return null
  const e = props.error as NuxtError & { data?: unknown, stack?: string, cause?: unknown }
  return {
    statusCode: e.statusCode,
    statusMessage: e.statusMessage,
    message: e.message,
    data: e.data,
    stack: e.stack,
    url: route.fullPath,
  }
})

const shellClasses = computed(() => {
  const c: string[] = []
  if (monsterClicks.value === 6)
    c.push('shake', 'shake-constant')
  if (pageForcesDark.value)
    c.push('dark')
  return c
})

useSeoMeta({
  title: () => `${statusCode.value} ${errorContent.value.title}`,
  robots: 'noindex',
})

useHead({
  bodyAttrs: {
    style: computed(() => `background-color: ${pageForcesDark.value ? 'var(--color-monster-950)' : 'var(--ui-bg)'}`),
  },
  meta: [
    {
      name: 'theme-color',
      content: computed(() => effectiveDark.value ? '#1a0f0d' : '#fdfaf6'),
    },
  ],
})

function goHome() {
  return clearError({ redirect: '/' })
}

function goGames() {
  return clearError({ redirect: '/games' })
}

function retryRoute() {
  return clearError({ redirect: route.fullPath || '/' })
}

return (_ctx: any,_cache: any) => {
  const _component_TheHeader = _resolveComponent("TheHeader")!
  const _component_LazyTheMonster = _resolveComponent("LazyTheMonster")!
  const _component_MCloudsTop = _resolveComponent("MCloudsTop")!
  const _component_NuxtImg = _resolveComponent("NuxtImg")!
  const _component_MMotionButton = _resolveComponent("MMotionButton")!
  const _component_MMotionLift = _resolveComponent("MMotionLift")!
  const _component_SiteIntroduction = _resolveComponent("SiteIntroduction")!
  const _component_NuxtLayout = _resolveComponent("NuxtLayout")!
  const _component_UApp = _resolveComponent("UApp")!

  return (_openBlock(), _createBlock(_unref(LazyMotion), { features: _unref(domMax) }, {
    default: _withCtx(() => [
      _createVNode(_unref(MotionConfig), { "reduced-motion": "user" }, {
        default: _withCtx(() => [
          _createVNode(_component_UApp, { toaster: { position: 'top-right', duration: 4000 } }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(["flex min-h-screen flex-col", _unref(shellClasses)])
              }, [
                (!_unref(isAdminRoute))
                  ? (_openBlock(), _createBlock(_component_TheHeader, {
                      key: 0,
                      absolute: ""
                    }))
                  : _createCommentVNode("", true),
                (!_unref(isAdminRoute))
                  ? (_openBlock(), _createBlock(_component_LazyTheMonster, { key: 1 }))
                  : _createCommentVNode("", true),
                (!_unref(isAdminRoute))
                  ? (_openBlock(), _createBlock(_component_MCloudsTop, {
                      key: 2,
                      class: "relative z-[11] h-0 [&::after]:!hidden"
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_NuxtLayout, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_SiteIntroduction, null, {
                      default: _withCtx(() => [
                        (_openBlock(), _createBlock(_component_NuxtImg, {
                          key: _unref(errorContent).image,
                          class: "mx-auto block h-auto max-w-full",
                          src: _unref(errorContent).image,
                          alt: "",
                          role: "presentation",
                          loading: "eager",
                          fetchpriority: "high",
                          width: _unref(errorContent).imageWidth,
                          height: _unref(errorContent).imageHeight
                        }, null, 8, ["src", "width", "height"])),
                        _createElementVNode("p", _hoisted_1, _toDisplayString(_unref(statusCode)) + " Error ", 1),
                        _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(errorContent).title), 1),
                        _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(errorContent).message), 1),
                        (_unref(errorDetails))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                              _createElementVNode("details", _hoisted_5, [
                                _createElementVNode("summary", _hoisted_6, " Error details (" + _toDisplayString(_unref(errorDetails).statusCode) + ") ", 1),
                                _createElementVNode("dl", _hoisted_7, [
                                  (_unref(errorDetails).url)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                        _cache[2] || (_cache[2] = _createElementVNode("dt", { class: "text-muted" }, " URL ", -1)),
                                        _createElementVNode("dd", _hoisted_9, _toDisplayString(_unref(errorDetails).url), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_unref(errorDetails).statusMessage)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                        _cache[3] || (_cache[3] = _createElementVNode("dt", { class: "text-muted" }, " Status ", -1)),
                                        _createElementVNode("dd", _hoisted_11, _toDisplayString(_unref(errorDetails).statusMessage), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_unref(errorDetails).message)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                        _cache[4] || (_cache[4] = _createElementVNode("dt", { class: "text-muted" }, " Message ", -1)),
                                        _createElementVNode("dd", _hoisted_13, _toDisplayString(_unref(errorDetails).message), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_unref(errorDetails).data)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                        _cache[5] || (_cache[5] = _createElementVNode("dt", { class: "text-muted" }, " Data ", -1)),
                                        _createElementVNode("dd", null, [
                                          _createElementVNode("pre", _hoisted_15, _toDisplayString(typeof _unref(errorDetails).data === 'string' ? _unref(errorDetails).data : JSON.stringify(_unref(errorDetails).data, null, 2)), 1)
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_unref(errorDetails).stack)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                        _cache[6] || (_cache[6] = _createElementVNode("dt", { class: "text-muted" }, " Stack ", -1)),
                                        _createElementVNode("dd", null, [
                                          _createElementVNode("pre", _hoisted_17, _toDisplayString(_unref(errorDetails).stack), 1)
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_18, [
                          _createVNode(_component_MMotionLift, { class: "inline-block w-full sm:w-auto" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_MMotionButton, {
                                variant: "textured",
                                size: "2xl",
                                long: "",
                                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(errorContent).primaryAction()))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(errorContent).primaryLabel), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_MMotionLift, { class: "inline-block w-full sm:w-auto" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_MMotionButton, {
                                variant: "textured",
                                color: "secondary",
                                size: "2xl",
                                long: "",
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(errorContent).secondaryAction()))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(errorContent).secondaryLabel), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ], 2)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["features"]))
}
}

})